import { ByOrder, TopCustomers } from '@/interfaces/dashboard.interface';
import React, { useMemo } from 'react';
import CommonTable, { TableColumn } from '../common/commonTable/CommonTable';
import { toFixedThree } from '@/utility/helper';
import { ActionConfig } from '@/interfaces/common.interface';
import { usePermissions } from '@/hooks/usePermissions';
import { useNavigate } from 'react-router-dom';
import { RoutesLink } from '@/utility/RouteLinks';
import Card from '../UI/Card';

interface TopCustomersProp {
  topCustomers: TopCustomers;
}

const TopCustomersList: React.FC<TopCustomersProp> = ({ topCustomers }) => {
  const navigate = useNavigate();
  const { canView } = usePermissions();
  const columns: TableColumn<ByOrder>[] = [
    {
      key: 'customerName',
      header: 'Name',
      render: (item) => <span>{item.customerName || 'Unkown'}</span>,
    },
    {
      key: 'sales',
      header: 'Total Spent (BHD)',
      render: (item) => toFixedThree(item?.sales || 0),
    },
    {
      key: 'count',
      header: 'Count',
    },
  ];

  const userActionConfig: Record<string, ActionConfig<ByOrder>> = {
    view: {
      text: 'View',
      onClick: (user) =>
        navigate(`${RoutesLink.customerDetails}/${user.userId}`),
      permission: () => canView('user'),
    },
  };

  const actions = useMemo(
    () =>
      Object.values(userActionConfig)
        .filter((action) => action.permission())
        .map(({ permission, ...rest }) => rest),
    [canView],
  );

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <Card>
        <h3 className="text-base text-black mb-2">
          Top Customers (Order Count)
        </h3>
        <CommonTable
          columns={columns}
          data={topCustomers.byOrders}
          getItemId={(item) => item.userId}
          emptyMessage="No products found"
          minHeight="min-h-96"
          actions={actions}
        />
      </Card>
      <Card>
        <h3 className="text-base text-black mb-2">Top Customers (Spending) </h3>
        <CommonTable
          columns={columns}
          data={topCustomers.bySales}
          getItemId={(item) => item.userId}
          emptyMessage="No products found"
          minHeight="min-h-96"
          actions={actions}
        />
      </Card>
    </div>
  );
};

export default TopCustomersList;
